import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#143A5F"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M3.333 7.99v.02A4.01 4.01 0 0 0 7.343 12V4c-2.209 0-3.999 1.786-4.01 3.99"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M7.332 11.998h4.003V4h-4v.015c2.19 0 3.965 1.794 3.965 3.983s-1.775 3.978-3.966 3.978v.022z"
    }, null, -1)
  ])))
}
export default { render: render }